import rectangleIcon from "./imgs/rectangleIcon.svg";
import ellipseIcon from "./imgs/ellipseIcon.svg";
import gridIcon from "./imgs/gridIcon.svg";
import stackPanelIcon from "./imgs/stackPanelIcon.svg";
import textBoxIcon from "./imgs/textBoxIcon.svg";
import sliderIcon from "./imgs/sliderIcon.svg";
import imageBasedSliderIcon from "./imgs/imageSliderIcon.svg";
import buttonIcon from "./imgs/buttonIcon.svg";
import passwordFieldIcon from "./imgs/passwordFieldIcon.svg";
import checkboxIcon from "./imgs/checkboxIcon.svg";
import imageIcon from "./imgs/imageIcon.svg";
import keyboardIcon from "./imgs/keyboardIcon.svg";
import inputFieldIcon from "./imgs/inputFieldIcon.svg";
import lineIcon from "./imgs/lineIcon.svg";
import displaygridIcon from "./imgs/displaygridIcon.svg";
import colorPickerIcon from "./imgs/colorPickerIcon.svg";
import scrollbarIcon from "./imgs/scrollbarIcon.svg";
import radioButtonIcon from "./imgs/radioButtonIcon.svg";

export const ControlTypes = [
    {
        className: "Rectangle",
        icon: rectangleIcon,
    },
    {
        className: "Ellipse",
        icon: ellipseIcon,
    },
    {
        className: "StackPanel",
        icon: stackPanelIcon,
    },
    {
        className: "Grid",
        icon: gridIcon,
    },
    {
        className: "ScrollViewer",
        icon: scrollbarIcon,
    },
    {
        className: "Line",
        icon: lineIcon,
    },
    {
        className: "TextBlock",
        icon: textBoxIcon,
    },
    {
        className: "InputText",
        icon: inputFieldIcon,
    },
    {
        className: "InputPassword",
        icon: passwordFieldIcon,
    },
    {
        className: "Image",
        icon: imageIcon,
    },
    {
        className: "DisplayGrid",
        icon: displaygridIcon,
    },
    {
        className: "Button",
        icon: buttonIcon,
    },
    {
        className: "Checkbox",
        icon: checkboxIcon,
    },
    {
        className: "RadioButton",
        icon: radioButtonIcon,
    },
    {
        className: "Slider",
        icon: sliderIcon,
    },
    {
        className: "ImageBasedSlider",
        icon: imageBasedSliderIcon,
    },
    {
        className: "VirtualKeyboard",
        icon: keyboardIcon,
    },
    {
        className: "ColorPicker",
        icon: colorPickerIcon,
    },
];
